module.exports = __webpack_public_path__ + "img/con-img-1.c42251d9.png";